"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRewardsBonus = void 0;
/**
 * Formats a given string.
 *
 * @param {any} value - The value to be formatted.
 * @returns {string} - The formatted string.
 */
const formatRewardsBonus = (rewardsBonus) => {
    if (rewardsBonus === undefined) {
        return "";
    }
    const { amount, amountSubtext } = rewardsBonus;
    return `${amount}${amountSubtext ? ` ${amountSubtext}` : ""}`;
};
exports.formatRewardsBonus = formatRewardsBonus;
